import { Feature } from "@shared/models";

export const NamesOfParentRoutes = {
  AUTH: "/auth",
  DASHBOARD: "/",
  OAUTH: "/oauth",
};

export const NameOfRoutes = {
  SIGN_IN: "/",
  SIGN_UP: "/signup",
  AUTH: "/auth/",
  AUTH_LOGIN: "/auth/login",
  CHECK_USER: "/auth/user",
  AUTH_REGISTRATION: "/auth/registration",
  AUTH_FORGOT_PASSWORD: "/auth/restore",
  AUTH_CHANGE_PASSWORD: "/auth/change",
  FILE: "files",
  CLARITAS: "flikid",
  DATA_DELIVERY_UPDATES: "data-delivery",
  PROPERTIES: "properties",
  PAY_PER_LEAD: "pay-per-lead",
  TICKETS: "tickets",
  NICHE_FILES: "stacked-niche-files",
  USER_MANAGEMENT: "user-management",
  INTEGRATIONS: "integrations",
  WEBHOOKS: "webhooks",
  API_KEYS: "api-keys",
  REI_SIFT: "reisift",
  RESEARCH: "research",
  SUBSCRIPTIONS: "subscriptions",
};

export const NameOfChildRoutes = {
  AUTH: {
    LOGIN: "/login",
    CHECK_USER: "/user",
    FORGOT_PASSWORD: "/restore",
    RESET_PASSWORD: "/recovery/:hash",
    SET_PASSWORD: "/signup/:hash",
    REGISTRATION: "/registration",
  },
  SKIP_TRACING: {
    ROOT: "/skip-tracings",
    CREATE: "/new",
    DETAILS: "/:id",
    LIST: "/",
  },
  USER_MANAGEMENT: {
    ROOT: "/user-management",
    LIST: "",
    CREATE: "/new",
    EDIT: "/:id/edit",
  },
  CONTACT: {
    ROOT: "/contacts",
    CREATE: "/new",
    DETAILS: "/:id",
    LIST: "/",
    PRESET: {
      ROOT: "/presets",
      CREATE: "/new",
      DETAILS: "/:presetId",
      LIST: "/",
    },
    DEPLOY_LISTS: {
      ROOT: "/deploy-lists",
      CREATE: "/new",
      DETAILS: "/:deployListId",
      LIST: "/",
    },
    WEBHOOKS: {
      ROOT: "/webhooks",
    },
    API_KEYS: {
      ROOT: "/api-keys",
    },
    REI_SIFT: {
      ROOT: "/reisift",
    },
  },
  INVESTOR: {
    ROOT: "/predictive-ai",
    LIST: "/",
    UPLOAD: "/upload",
    MONTHLY_FILES: "/monthly-files",
  },
  MARKET_MAP: {
    ROOT: "/market-map",
  },
  PROPERTIES: {
    DASHBOARD: "",
    PROPERTY: "/:id",
  },
  PRESET_BUILDER: {
    ROOT: "/preset-builder",
  },
  FILE: {
    DOWNLOAD_MULTIPLE: "/download",
    DOWNLOAD: "/:id/download",
  },
  CLARITAS: {
    DASHBOARD: "",
  },
  DATA_DELIVERY_UPDATES: {
    DASHBOARD: "",
  },
  PRESET_SUCCESS: {
    ROOT: "/preset-success",
  },
  PRESET_ERROR: {
    ROOT: "/preset-error",
  },
  PRESET_NOT_FOUND: {
    ROOT: "/preset-not-found",
  },
  PRESET_NORMAL: {
    ROOT: "/preset-normal",
  },
  PRESET_LOADING: {
    ROOT: "/preset-loading",
  },
  PAY_PER_LEAD: {
    ROOT: "/pay-per-lead",
    DASHBOARD: "",
    ADMIN_ITEM: "leads/:id",
    ITEM: ":id",
    SUBSCRIPTIONS: "subscriptions",
    CONFIRM: "confirm",
    ACTIVATE: "activate",
    DEACTIVATE: "deactivate",
    ADD: "add",
    DISPUTES: "disputes",
    CUSTOMERS: "customers",
    LEADS: "leads",
    SUBSCRIPTIONS_LIST: "subscriptions-list",
    COUNTIES: "counties",
    REJECTED_LEADS: "rejected-leads",
    INCOMPLETE_LEADS: "incomplete-leads",
    REJECTED_LEADS_SESSION: "rejected-leads/:sessionId",
    INCOMPLETE_LEADS_SESSION: "incomplete-leads/:sessionId",
  },
  TICKETS: {
    ROOT: "/tickets",
  },
  NICHE_FILES: {
    ROOT: "/stacked-niche-files",
    LIST: "",
    SUBSCRIPTION: "/subscriptions/:id",
    SUBSCRIPTIONS: "/subscriptions",
  },
  SUBSCRIPTIONS: {
    ROOT: "/subscriptions",
    LIST: "",
  },
};

export const ProductRedirects = {
  "stacked-niche-data": {
    url: `${NameOfChildRoutes.NICHE_FILES.ROOT}${NameOfChildRoutes.NICHE_FILES.SUBSCRIPTIONS}/new`,
    feature: Feature.NicheFiles,
  },
  ppl: {
    url: `${NameOfChildRoutes.PAY_PER_LEAD.ROOT}/${NameOfChildRoutes.PAY_PER_LEAD.SUBSCRIPTIONS}/${NameOfChildRoutes.PAY_PER_LEAD.ADD}`,
    feature: Feature.PayPerLead,
  },
  "market-map": {
    url: NameOfChildRoutes.MARKET_MAP.ROOT,
    feature: Feature.MarketMap,
  },
};
